module.exports = __webpack_public_path__ + "img/PgSQL.9474528e.svg";